import { render, staticRenderFns } from "./MigrationMessage.vue?vue&type=template&id=7a3849f8&scoped=true"
import script from "./MigrationMessage.vue?vue&type=script&lang=ts"
export * from "./MigrationMessage.vue?vue&type=script&lang=ts"
import style0 from "./MigrationMessage.vue?vue&type=style&index=0&id=7a3849f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3849f8",
  null
  
)

export default component.exports